import { useState, useRef, useEffect } from 'react';
import { useResponsiveScreen } from './useResponsiveScreen';
export function usePopoverInteraction(hoverDelay = 200) {
    const { isMobile } = useResponsiveScreen();
    const [showContextMenu, setShowContextMenu] = useState(false);
    const [showDesktopComponent, setShowDesktopComponent] = useState(false);
    const [anchorEl, setAnchorEl] = useState(null);
    const [isHovering, setIsHovering] = useState(false);
    const [activeItemId, setActiveItemId] = useState(null);
    const hoverTimeoutRef = useRef(null);
    useEffect(() => {
        return () => {
            if (hoverTimeoutRef.current) {
                clearTimeout(hoverTimeoutRef.current);
            }
        };
    }, []);
    const handleMouseEnter = (e, itemId) => {
        if (isMobile)
            return;
        if (activeItemId && activeItemId !== itemId) {
            setIsHovering(false);
            setShowDesktopComponent(false);
        }
        setActiveItemId(itemId);
        setAnchorEl(e.currentTarget);
        if (hoverTimeoutRef.current) {
            clearTimeout(hoverTimeoutRef.current);
        }
        setIsHovering(true);
    };
    const handleMouseLeave = () => {
        if (isMobile)
            return;
        if (!showDesktopComponent) {
            hoverTimeoutRef.current = setTimeout(() => {
                setIsHovering(false);
                setActiveItemId(null);
            }, hoverDelay);
        }
    };
    const handleClickShowInformation = (e, itemId) => {
        e.stopPropagation();
        if (activeItemId && activeItemId !== itemId) {
            setIsHovering(false);
            setShowDesktopComponent(false);
        }
        setActiveItemId(itemId);
        setAnchorEl(e.currentTarget);
        if (isMobile) {
            setShowContextMenu(!showContextMenu);
            setShowDesktopComponent(false);
        }
        else {
            setShowDesktopComponent(!showDesktopComponent);
        }
    };
    const handleClosePopover = () => {
        setShowDesktopComponent(false);
        setIsHovering(false);
        setActiveItemId(null);
    };
    const showPopover = !isMobile && (showDesktopComponent || isHovering);
    return {
        showContextMenu,
        showDesktopComponent,
        anchorEl,
        isHovering,
        activeItemId,
        showPopover,
        handleMouseEnter,
        handleMouseLeave,
        handleClickShowInformation,
        handleClosePopover,
        setShowContextMenu
    };
}
